import { render, staticRenderFns } from "./spm-core-pane.vue?vue&type=template&id=e119cd6c&scoped=true"
import script from "./spm-core-pane.vue?vue&type=script&lang=js"
export * from "./spm-core-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e119cd6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e119cd6c')) {
      api.createRecord('e119cd6c', component.options)
    } else {
      api.reload('e119cd6c', component.options)
    }
    module.hot.accept("./spm-core-pane.vue?vue&type=template&id=e119cd6c&scoped=true", function () {
      api.rerender('e119cd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/spm-core-pane.vue"
export default component.exports